import React, { Component } from 'react'

export default class ProviderDetails extends Component {
    render() {
        return (
            <div style={{background:'#F4F8FF', width:'100%'}}>
                Hello
            </div>
        )
    }
}
